import { FlyoutActionDirective } from './flyout-action.directive';
import { FlyoutCloseDirective } from './flyout-close.directive';
import { FlyoutZoneDirective } from './flyout-zone.directive';
import { FlyoutDirective } from './flyout.directive';

export const Directives = [
	FlyoutActionDirective,
	FlyoutCloseDirective,
	FlyoutZoneDirective,
	FlyoutDirective,
];
